import React from "react";
import PropTypes from "prop-types";

import { TextValue } from "scenes/Hubly/components/Workspace/components/FormFieldList/components";

export function FormFieldText({ formFieldType, value, datePart }) {
  const getType = () => {
    const getTypeByDatePart = () => {
      return datePart === "Date"
        ? { id: "DATE" }
        : { id: "MULTISELECT_DROPDOWN" };
    };

    return ["DATETIME", "DATE"].includes(formFieldType.id)
      ? getTypeByDatePart()
      : formFieldType;
  };

  return (
    <div data-test="form-field-text">
      <TextValue
        style={{
          padding: "0.3em 0.4em",
          margin: "0 0.5em 0.2em 0",
          wordBreak: "break-all",
        }}
        type={getType()}
        value={value}
        prefix=""
      />
    </div>
  );
}

FormFieldText.propTypes = {
  formFieldType: PropTypes.shape({ id: PropTypes.string }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  datePart: PropTypes.string,
};

FormFieldText.defaultProps = { value: null, datePart: null };

export default FormFieldText;
